import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { pure } from 'recompose';
import get from 'lodash/get';
import { getTranslationByLocale } from '../../utils/TranslationUtils';

export const TranslatableField = ({ data, source, record = {}, elStyle, richText, locale }) => {
  const translation = getTranslationByLocale(data || get(record, source), locale);
  if (richText) {
    return (<span dangerouslySetInnerHTML={{ __html: translation }} />);
  }
  return (<span style={elStyle}>{translation}</span>);
};

TranslatableField.propTypes = {
  locale: PropTypes.string.isRequired,
  elStyle: PropTypes.object,
  data: PropTypes.object,
  addLabel: PropTypes.boolean, // eslint-disable-line
  record: PropTypes.object,
  source: PropTypes.string,
};

TranslatableField.defaultProps = {
  addLabel: true,
};

const mapStateToProps = (state) => ({ locale: state.locale });

export default connect(mapStateToProps)(pure(TranslatableField));
